import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/appoint/icon_tips.png'


const _withScopeId = n => (_pushScopeId("data-v-54ff68b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-item" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "预约信息")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-item" }, null, -1))
const _hoisted_5 = { class: "appoint-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您好，您正在预约", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ",请选择预约时间，完成预约。", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-item" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appoint-time-tips" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", null, "每周日上午10点开放下周预约")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-item" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "预约日期")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-item" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日期", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "|", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-item" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-item" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "预约时间段")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-item" }, null, -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "time-zone" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-item" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1))
const _hoisted_23 = { class: "tips" }

import { Dialog, Toast } from 'vant';
import { Ref, ref, onMounted, watch, onUnmounted } from 'vue';

import Api from '@/http/api/index'
import { useRouter } from "vue-router";
interface AppointDateInfoListItem {
    appointGovInfoId: string,
    appointGovItemId: string,
    openTime: string,
    appointDate: string,
    status: string,
    createTime: string,
    updateTime: string,
}

interface AppointInitDataEntity {
    realName: string,
    appointFull: string,
    remark: string,
    appointGovItemName: string,
    appointGovInfoList: AppointDateInfoListItem[]
}

interface AppointDetailListItem {
    appointGovDetailId: string,
    appointGovItemId: string,
    appointGovInfoId: string,
    appointDate: string,
    startTime: string,
    endTime: string,
    number: string,
    curNumber: string,
    appointStatus: string,
    remark: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const TAG = "taxDateTimeSelection";

const router = useRouter();

const dateTimeList: Ref<string[]> = ref([]);

const realName: Ref<string> = ref('');
const appointGovItemName: Ref<string> = ref('');

const appointDetailList: Ref<AppointDetailListItem[]> = ref([])

let appointInitDataEntity: AppointInitDataEntity | null = null;

let memberId: string = '';
let serviceId: string = '';

const loading = ref(false);


const onRefresh = () => {
    // let toast: { clear: () => void } = Toast.loading({
    //     message: '加载中...',
    //     duration: 5000
    // });
    loadData(() => {
        (selectedDateIndex.value !== -1) && refreshData(selectedDateIndex.value);
        setTimeout(() => {
            loading.value = false;
            // toast.clear();
        }, 100);

    }, () => {
        setTimeout(() => {
            loading.value = false;
            // toast.clear();
        }, 100);
    })
};

const show = ref(false);//遮罩层
const loadingOverLay = ref(false);//遮罩层---加载数据时显示

const currentDate = ref(new Date(2023, 10, 27));
const minDate = new Date(2023, 0, 1);
const maxDate = new Date(2035, 10, 1);
const selectedDateIndex: Ref<number> = ref(-1);
const remark: Ref<string> = ref('')

const selectedDateTime = ref('');

watch(selectedDateIndex, (value) => {
    // console.log("########watch selectedDateIndex value:", value);
    (value !== -1) && refreshData(value);
    setTimeout(() => {
        refreshDataInSpecialTimePoint();
    }, 200);
})

const onConfirm = (value: string, index: number) => {
    // Toast(`当前值: ${value.getTime()}, 当前索引: ${index}`);
    // let year = value.getFullYear();
    // let month = value.getMonth() + 1;  // 获取月份（注意月份从0开始，所以需要加1）  
    // let day = value.getDate();  // 获取日期  
    // // 确保每个部分都有两位数字（除了年份）  
    // month = month < 10 ? '0' + month : month;
    // day = day < 10 ? '0' + day : day;
    // selectedDateTime.value = year + '-' + month + '-' + day
    selectedDateTime.value = value;
    selectedDateIndex.value = index;
};

const onChange = (value: string, index: number) => {
    selectedDateTime.value = value;
    selectedDateIndex.value = index;
};
let appointTimeout: number = -1;
const onCancel = () => Toast('取消');
const clickAppointment = (index: number) => {
    Dialog.confirm({
        // title: '标题',
        message: `<div style="font-size:17px;line-height:26px;"><span style='font-size:18px;color:red;'>${realName.value}</span> 您好，您确认预约时间段为<span style="color:red;font-size:18px;"> ${appointDetailList.value[index].appointDate} ${appointDetailList.value[index].startTime}-${appointDetailList.value[index].endTime}</span> <span style="font-size:18px;color:red;"> ${appointGovItemName.value}</span>吗？</div>`,
        allowHtml: true,
        messageAlign: 'center',
        confirmButtonText: '确认预约',
        cancelButtonText: '再想想',
    }).then(() => {
        // on confirm
        submitDateAppoint(appointDetailList.value[index].appointGovDetailId, () => {
            loadingOverLay.value = true;
            Toast.success({
                message: "预约成功！",
                onClose: () => {
                    loadingOverLay.value = false;
                    router.replace({
                        path: '/taxAppointmentRecord',
                        query: {
                            memberId
                        }
                    })
                }
            });
            // Toast.success('预约成功！');
            // setTimeout(() => {
            //     router.replace({
            //         path: '/taxAppointmentRecord',
            //         query: {
            //             memberId
            //         }
            //     })
            // }, 1200)
        }, value => {
        })
    }).catch(() => {
        // on cancel
    });
}

onMounted(() => {
    loadData(() => {
        refreshDataInSpecialTimePoint();
    }, () => { });

})

onUnmounted(() => {
    clearAppointmentTimeout();
})

const refreshDataInSpecialTimePoint = () => {
    appointInitDataEntity && selectedDateIndex.value !== -1 && getRestTimeOfSecKill(`${appointInitDataEntity?.appointGovInfoList[selectedDateIndex.value].appointGovInfoId}`, (timeDuration) => {
        if (parseInt(timeDuration) > 0) {
            clearAppointmentTimeout();
            appointTimeout = setTimeout(() => {
                appointTimeout = -1;
                (selectedDateIndex.value !== -1) && refreshData(selectedDateIndex.value);
            }, (parseInt(timeDuration) + 50))
        }
        // else {
        //      console.log("#############111")
        //     appointTimeout = setTimeout(() => {
        //         console.log("#############222")
        //         appointTimeout = -1;
        //         (selectedDateIndex.value !== -1) && refreshData(selectedDateIndex.value);
        //     }, (parseInt(timeDuration) + 50 + (60 + 60) * 60 * 1000))
        // }
    }, (fail) => {

    });
}

const clearAppointmentTimeout = () => {
    if (appointTimeout != -1) {
        clearTimeout(appointTimeout);
        appointTimeout = -1;
    }
}


const refreshData = (dateIndex: number) => {
    let toast: { clear: () => void } = Toast.loading({
        message: '加载中...',
        duration: 6000
    });
    // show.value = true;
    loadingOverLay.value = true;
    getAppointDetailList(`${appointInitDataEntity?.appointGovInfoList[dateIndex].appointGovInfoId}`, (data: AppointDetailListItem[]) => {
        appointDetailList.value.splice(0, appointDetailList.value.length);
        setTimeout(() => {
            appointDetailList.value.splice(0, appointDetailList.value.length);
            appointDetailList.value.push(...data);
            loadingOverLay.value = false;
            toast.clear();
        }, 200);
    }, value => {
        setTimeout(() => {
            loadingOverLay.value = false;
            toast.clear();
        }, 100);
    })
}

const loadData = (success?: () => void, fail?: () => void) => {
    let currentMemberID = router.currentRoute.value.query.memberId;
    let currentServiceID = router.currentRoute.value.query.serviceId;
    if (currentMemberID) {
        memberId = `${currentMemberID}`;
    }
    if (currentServiceID) {
        serviceId = `${currentServiceID}`;
    }

    getAppointGovInfo(res => {
        appointInitDataEntity = res;
        remark.value = res.remark
        realName.value = res.realName;
        appointGovItemName.value = res.appointGovItemName;
        if (Array.isArray(res.appointGovInfoList)) {
            dateTimeList.value.splice(0, dateTimeList.value.length);
            dateTimeList.value.push(...res.appointGovInfoList.map(item => item.appointDate))
            if (res.appointGovInfoList.length > 0) {
                if (selectedDateIndex.value == -1) {
                    selectedDateIndex.value = 0;
                    selectedDateTime.value = res.appointGovInfoList[0].appointDate;
                }
            }
        }
        success && success();
    }, value => {
        fail && fail();
    })
}

const getAppointGovInfo = (success: (value: AppointInitDataEntity) => void, fail: (value: any) => void) => {
    Api.getAppointGovInfo({
        params: {
            memberId,
            appointGovItemId: serviceId,
        },
        success: (res: any) => {
            console.log('###getAppointGovInfo success:', res);
            if (res.code == 0) {
                success(res.data as AppointInitDataEntity)

            } else {
                Toast('' + res.msg)
                fail('' + res.msg)
            }
        },
        fail: (value: any) => {
            Toast('' + value)
            fail('' + value)
        }
    })
}

const getAppointDetailList = (appointGovInfoId: string, success: (value: AppointDetailListItem[]) => void, fail: (value: any) => void) => {
    Api.getAppointDetailList({
        params: {
            memberId,
            appointGovInfoId,
        },
        success: (res: any) => {
            console.log('### getAppointDetailList success:', res);
            if (res.code == 0) {
                success(res.data as AppointDetailListItem[]);
            } else {
                Toast('' + res.msg)
                fail('' + res.msg)
            }
        },
        fail: (value: any) => {
            Toast('' + value)
            fail('' + value)
        }
    })
}

const submitDateAppoint = (appointGovDetailId: string, success: () => void, fail: (value: any) => void) => {
    Api.submitDateAppoint({
        params: {
            memberId,
            appointGovDetailId,
        },
        success: (res: any) => {
            console.log('### submitDateAppoint success:', res);
            if (res.code == 0) {
                success();
            } else {
                Toast.fail('' + res.msg);

                fail('' + res.msg)
            }
        },
        fail: (value: any) => {
            Toast('' + value)
            fail('' + value)
        }
    })
}

const getRestTimeOfSecKill = (govInfoId: string, success?: (value: string) => void, fail?: (value: any) => void) => {
    Api.getRestTimeOfSecKill({
        params: {
            govInfoId
        },
        success: (res: any) => {
            console.log('###getRestTimeOfSecKill success:', res);
            if (res.code == 0) {
                success && success(res.data);
            } else {
                Toast.fail('' + res.msg);
                fail && fail('' + res.msg)
            }
        },
        fail: (value: any) => {
            Toast('' + value)
            fail && fail('' + value)
        }
    })
}


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      class: "pull-refresh",
      "success-text": "刷新成功",
      modelValue: loading.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((loading).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(realName.value), 1),
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(appointGovItemName.value), 1),
            _hoisted_7
          ]),
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", {
            class: "date-time-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = true))
          }, [
            _hoisted_13,
            _createElementVNode("span", null, _toDisplayString(selectedDateTime.value), 1),
            _hoisted_14,
            _createVNode(_component_van_icon, {
              name: "play",
              color: "#888"
            })
          ]),
          _hoisted_15,
          _hoisted_16,
          _hoisted_17,
          _hoisted_18,
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (appointDetailList.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointDetailList.value, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("span", null, _toDisplayString(item.startTime) + "-" + _toDisplayString(item.endTime), 1),
                          _createVNode(_component_van_button, {
                            onClick: ($event: any) => (clickAppointment(index)),
                            class: _normalizeClass({
                                    'disabled-btn': item.appointStatus != '0'
                                }),
                            disabled: !(item.appointStatus == '0')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 预约(" + _toDisplayString(item.curNumber) + "/" + _toDisplayString(item.number) + ") ", 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "class", "disabled"])
                        ]),
                        _hoisted_21
                      ], 64))
                    }), 256))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, _toDisplayString(remark.value), 1),
          _createVNode(_component_van_overlay, {
            show: show.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (show.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_picker, {
                title: "",
                columns: dateTimeList.value,
                onConfirm: onConfirm,
                onCancel: onCancel,
                onChange: onChange
              }, null, 8, ["columns"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_van_overlay, {
            show: loadingOverLay.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (loadingOverLay.value = false))
          }, null, 8, ["show"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})